import React, {useContext, useState} from "react";
import {PaymentPlanInfo, PlanFormat} from "../../../shared/types/payment-plan";
import {AuthContext} from "../../../shared/services/auth-context/auth-context";
import {PAYMENT_PLAN_API_PATH} from "../../../../global_vars";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTimes} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {Button} from "react-bootstrap";
import './add-payment-plan.scss'
import {APIResponse} from "../../../shared/types/types";

interface AddPaymentPlanProps {
    paymentPlanName: string;
    closePaymentPlanModal: () => void;
}

function AddPaymentPlan({paymentPlanName, closePaymentPlanModal}: AddPaymentPlanProps) {

    const {axiosRequestHelper} = useContext(AuthContext);

    const [state, setState] = useState<PaymentPlanInfo>({
        id: null,
        name: paymentPlanName,
        description: "",
        plan_format: [],
    });

    const [planFormat, setPlanFormat] = useState<PlanFormat>({
        stage: "",
        stage_description: "",
        percentage: null,
    });

    const [showStageForm, setShowStageForm] = useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setState({
            ...state,
            [name]: value,
        });
    };

    const handlePlanFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setPlanFormat({
            ...planFormat,
            [name]: (name === "percentage") ? parseFloat(value) : value,
        });
    };

    const addStage = () => {
        setState({
            ...state,
            plan_format: [
                ...state.plan_format,
                planFormat,
            ]
        });
        setPlanFormat({
            stage: "",
            stage_description: "",
            percentage: null,
        });
        setShowStageForm(false);
    }

    const removeStage = (stageName: string) => {
        setState({
            ...state,
            plan_format: state.plan_format.filter(plan => plan.stage !== stageName),
        });
    }

    const addPaymentPlan = () => {
        const paymentPlanInfo: PaymentPlanInfo = {
            id: null,
            name: state.name,
            description: state.description,
            plan_format: state.plan_format
        }
        console.log("Payment Plan: ", paymentPlanInfo);
        axiosRequestHelper.post<APIResponse>(`/v1${PAYMENT_PLAN_API_PATH}`, paymentPlanInfo).then(resp => {
            closePaymentPlanModal();
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    return (
        <div className="add-payment-plan">
            <form className="needs-validation">
                <h2>Add Payment Plan</h2>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group pb-3 pt-2">
                            <label htmlFor="name">Payment Plan Name</label>
                            <input type="text" className="form-control" placeholder="Enter Payment Plan Name"
                                   id="name" name="name" onChange={handleChange}
                                   value={state.name} required/>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group pb-3 pt-2">
                            <label htmlFor="description">Payment Plan Description</label>
                            <input type="text" className="form-control" placeholder="Enter Payment Plan Description"
                                   id="description" name="description" onChange={handleChange}
                                   value={state.description} required/>
                        </div>
                    </div>
                </div>
                <div className="plan-format">
                    <div className="d-flex justify-content-between">
                        <h4>Plan Format</h4>
                        {
                            !showStageForm && (
                                <Button className="btn btn-deepNavyBlue"
                                        onClick={() => {
                                            setShowStageForm(true)
                                        }}><FontAwesomeIcon icon={faPlus as IconProp} /></Button>
                            )
                        }
                    </div>


                    {
                        state.plan_format.map((plan, index) => (
                                <div className="stage-badge">
                                    <div className="stage-badge" key={index}>
                                        {plan.stage} - {plan.percentage}%
                                        <FontAwesomeIcon
                                            icon={faTimes as IconProp}
                                            onClick={() => removeStage(plan.stage)}
                                            style={{cursor: "pointer", marginLeft: "8px"}}
                                        />
                                    </div>
                                </div>
                            )
                        )
                    }

                    {
                        showStageForm && (
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group pb-3 pt-2">
                                        <label htmlFor="stage">Stage Name</label>
                                        <input type="text" className="form-control" placeholder="Enter Stage Name"
                                               id="stage" name="stage" onChange={handlePlanFormatChange}
                                               value={planFormat.stage} required/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group pb-3 pt-2">
                                        <label htmlFor="stage_description">Stage Description</label>
                                        <input type="text" className="form-control" placeholder="Enter Stage Description"
                                               id="stage_description" name="stage_description"
                                               onChange={handlePlanFormatChange}
                                               value={planFormat.stage_description} required/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group pb-3 pt-2">
                                        <label htmlFor="percentage">Payment Percentage</label>
                                        <input type="number" className="form-control" placeholder="Enter Payment Percentage"
                                               id="percentage" name="percentage" onChange={handlePlanFormatChange}
                                               value={planFormat.percentage ?? 0} required/>
                                    </div>
                                </div>
                                <div className="col-6 mt-5">
                                    <Button className="btn btn-primary" onClick={addStage}>Add Stage</Button>
                                </div>
                            </div>


                        )
                    }
                </div>
                <button type="button" className="btn btn-deepNavyBlue float-end mt-5" onClick={addPaymentPlan}>Add Payment Plan</button>
            </form>
        </div>
    );
}

export default AddPaymentPlan;